import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-StarShape",
  "use": "svg-icon-StarShape-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"svg-icon-StarShape\"><path d=\"M23.2 9.4l-7.9-.9L12 1.2 8.7 8.4l-7.9 1 5.8 5.4-1.5 7.8 6.9-3.9 6.9 3.9-1.5-7.8 5.8-5.4zM12 16.9l-4.8 2.7 1.1-5.4-4.1-3.8 5.5-.7 2.3-5 2.3 5 5.5.7-4.1 3.8 1.1 5.4-4.8-2.7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol